import React, { useState, createContext, ReactNode, Context } from 'react';

interface ColorModeContextType {
  colorMode: 'light' | 'dark',
  toggleColorMode: () => void
};

let colorModeFromStorage = (localStorage.getItem('colorMode') as 'light' | 'dark'); 

const ColorModeContext: Context<any> = createContext({ colorMode: colorModeFromStorage || 'dark', toggleColorMode: () => {} });

export function ColorModeContextProvider({ children }: { children: ReactNode }) {
  colorModeFromStorage = (localStorage.getItem('colorMode') as 'light' | 'dark'); 
  const [mode, setMode] = useState<'light' | 'dark'>(colorModeFromStorage || 'dark');
  const colorMode = React.useMemo(
    () => {
      return {
        colorMode: mode,
        toggleColorMode: () => {
          setMode((prevMode) => {
            const newMode = (prevMode === 'light' ? 'dark' : 'light');
            localStorage.setItem('colorMode', newMode);
            return newMode;
          });
        }
      };
    },
    [mode],
  );
  return (
    <ColorModeContext.Provider value={colorMode}>
      {children}
    </ColorModeContext.Provider>
  );
};

export default ColorModeContext;